import {createNotification} from "../components/Notifications/Notifications";
import { api } from "../App";
import {
    GET_APLICANT_GROUP_LIST,
    SET_APLICANT_GROUP_LIST_LOADING,
    SET_APLICANT_GROUP_BY_ID,
    SET_APLICANT_GROUP_BY_ID_LOADING,
    SET_APLICANT_GROUP_NAME_EXAMS,
    SET_APLICANT_GROUP_NAME_EXAMS_ADD,
    SET_APLICANT_GROUP_PHYSICAL_TRAINING,
    SET_APLICANT_GROUP_ADD_LIST
} from "./types";

export const getApplicantGroupList = (params) => async(dispatch, getState) => {
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: true});
    try {
        const { data } = await api.get(`/trials`, { params: { year: params.school_year } });
        dispatch({type: GET_APLICANT_GROUP_LIST, payload: data});
    } catch (error) {
        dispatch({type: GET_APLICANT_GROUP_LIST, payload: []});
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: false});
};

export const getApplicantGroupItem = (id) => async(dispatch, getState) => {
    dispatch({type: SET_APLICANT_GROUP_BY_ID_LOADING, payload: true});
    try {
        const { data: result } = await api.get(`/trials/${id}`);
        const list = getState().applicant_group.physical_training || [];
        const normalizedFS = result?.physical_standarts?.map(el => {
            const found = list.find(item => item.iname?.trim() === el.name?.trim());
            return {
                ...el,
                id: el.id || crypto.randomUUID(),
                iid: found?.iid ?? null,
                name: el.name
            };
        }) || [];

        const addApplicantsList = getState().applicant_group.aplicantList;
        if (result?.applicants && result?.applicants?.length > 0) {
            dispatch({type: SET_APLICANT_GROUP_ADD_LIST, payload: [...result.applicants, ...addApplicantsList]});
        }

        dispatch({
            type: SET_APLICANT_GROUP_BY_ID,
            payload: {...result, physical_standarts: normalizedFS}
        });
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
    dispatch({type: SET_APLICANT_GROUP_BY_ID_LOADING, payload: false});
};

export const getApplicantNameExams = () => async(dispatch, getState) => {
    try {
        const { data } = await api.get(`/applicant_group/name_exams`);
        dispatch({type: SET_APLICANT_GROUP_NAME_EXAMS, payload: data});
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
};

export const getApplicantAddList = () => async(dispatch, getState) => {
    try {
        const { data } = await api.get(`/applicant_group/add_applicant`);
        dispatch({type: SET_APLICANT_GROUP_ADD_LIST, payload: data});
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
};

export const getApplicantAddNameExams = () => async(dispatch, getState) => {
    try {
        const { data } = await api.get(`/applicant_group/add_name_exams`);
        dispatch({type: SET_APLICANT_GROUP_NAME_EXAMS_ADD, payload: data});
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
};

export const getApplicantPhysicalTraining = () => async(dispatch, getState) => {
    try {
        const { data } = await api.get(`/physical_training`);
        dispatch({type: SET_APLICANT_GROUP_PHYSICAL_TRAINING, payload: data});
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
};

export const updateApplicantGroup = (id, data, params) => async(dispatch, getState) => {
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: true});
    try {
        await api.put(`/trials/${id}`, data);
        await dispatch(getApplicantGroupItem(id));
        await dispatch(getApplicantGroupList(params));
        await dispatch(getApplicantAddList());
        createNotification('success', 'Успешно!');
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: false});
}

export const createApplicantGroup = (data, params) => async(dispatch, getState) => {
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: true});
    try {
        await api.post(`/trials`, data);
        createNotification('success', 'Успешно');
        await dispatch(getApplicantGroupList(params));
        await dispatch(getApplicantAddList());
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: false});
};

export const deleteApplicantGroup = (id, params) => async(dispatch, getState) => {
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: true});
    try {
        await api.delete(`/trials/${id}`);
        createNotification('success', 'Успешно');
        await dispatch(getApplicantGroupList(params));
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка');
    }
    dispatch({type: SET_APLICANT_GROUP_LIST_LOADING, payload: false});
};

// Не задокументирован в Postman-коллекции — эндпойнт может отсутствовать на бэкенде
export const getApplicantGroupResults = (params) => async(dispatch) => {
    try {
        const query = new URLSearchParams({
            ...(params.school_year && { school_year: params.school_year }),
            ...(params.stream && { stream: params.stream }),
            ...(params.class_year && { class_year: params.class_year }),
            ...(params.group && params.group !== 'all' && { group: params.group }),
            ...(params.subject && params.subject !== 'all' && { subject: params.subject }),
        }).toString();
        const { data } = await api.get(`/applicant_group/results?${query}`);
        return Array.isArray(data) ? data : [];
    } catch (error) {
        createNotification('error', error.response?.data?.error || 'Ошибка загрузки результатов');
        return [];
    }
};